import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const formatPastPosition = ({
	pp_organization_name: organizationName,
	pp_position_title: positionTitle,
	pp_time_period: timePeriod,
}) => {
	let pastPosition = organizationName;

	if (positionTitle) {
		pastPosition += `, ${positionTitle}`;
	}
	if (timePeriod) {
		pastPosition += `, ${timePeriod}`;
	}

	return pastPosition;
};

const PastPositions = (props) => {
	const pastPositions = props.data.past_positions;

	if (!_.isArray(pastPositions) || _.isEmpty(pastPositions)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(pastPositions, pastPosition => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>
					{formatPastPosition(pastPosition)}
				</li>
			))}
		</ul>
	);
};

PastPositions.propTypes = {
	data: PropTypes.object.isRequired,
};

export default PastPositions;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/past-positions.js